// Generated by `bun run --filter @esi/shared catalogue:sync` (scripts/catalogue-sync.ts):
// do not edit. Filtered from @opencode-ai/models@0.0.119, snapshot 2026-10-29T05:26:25.333Z.
/**
 * Model metadata from models.dev (https://models.dev), redistributed under its licence:
 *
 * MIT License
 *
 * Copyright (c) 2025 models.dev
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import type { CanonicalModel, CanonicalSource } from "./canonical.ts";

export const CANONICAL_SOURCE: CanonicalSource = {
  package: "@opencode-ai/models",
  version: "0.0.119",
  generatedAt: "2026-10-29T05:26:25.333Z",
};

export const CANONICAL_MODELS: Readonly<Record<string, CanonicalModel>> = {
  "amazon/nova-2-lite": {
    id: "amazon/nova-2-lite",
    lab: "amazon",
    name: "Nova 2 Lite",
    family: "nova",
    releaseDate: "2025-12-02",
    knowledge: "2025-10",
    modalities: {
      input: ["text", "image", "video", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 1000000,
      output: 65536,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "amazon.nova-2-lite-v1:0": {
          name: "Nova 2 Lite",
          cost: {
            input: 0.33,
            output: 2.75,
            cacheRead: 0.0825,
            cacheWrite: 0.33,
          },
        },
        "eu.amazon.nova-2-lite-v1:0": {
          name: "Nova 2 Lite (EU)",
          cost: {
            input: 0.374,
            output: 3.157,
            cacheRead: 0.0935,
            cacheWrite: 0.374,
          },
        },
        "global.amazon.nova-2-lite-v1:0": {
          name: "Nova 2 Lite (Global)",
          cost: {
            input: 0.3,
            output: 2.5,
            cacheRead: 0.075,
            cacheWrite: 0.3,
          },
        },
      },
    },
  },
  "amazon/nova-lite": {
    id: "amazon/nova-lite",
    lab: "amazon",
    name: "Nova Lite",
    family: "nova-lite",
    releaseDate: "2024-12-03",
    knowledge: "2024-10",
    modalities: {
      input: ["text", "image", "video", "pdf"],
      output: ["text"],
    },
    reasoning: false,
    toolCall: true,
    temperature: true,
    limit: {
      context: 300000,
      output: 10000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "amazon.nova-lite-v1:0": {
          name: "Nova Lite",
          cost: {
            input: 0.06,
            output: 0.24,
            cacheRead: 0.015,
            cacheWrite: 0.06,
          },
        },
        "eu.amazon.nova-lite-v1:0": {
          name: "Nova Lite (EU)",
          cost: {
            input: 0.069,
            output: 0.276,
            cacheRead: 0.01725,
            cacheWrite: 0.069,
          },
        },
      },
    },
  },
  "amazon/nova-micro": {
    id: "amazon/nova-micro",
    lab: "amazon",
    name: "Nova Micro",
    family: "nova-micro",
    releaseDate: "2024-12-03",
    knowledge: "2024-10",
    modalities: {
      input: ["text"],
      output: ["text"],
    },
    reasoning: false,
    toolCall: true,
    temperature: true,
    limit: {
      context: 128000,
      output: 10000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "amazon.nova-micro-v1:0": {
          name: "Nova Micro",
          cost: {
            input: 0.035,
            output: 0.14,
            cacheRead: 0.00875,
            cacheWrite: 0.035,
          },
        },
        "eu.amazon.nova-micro-v1:0": {
          name: "Nova Micro (EU)",
          cost: {
            input: 0.04,
            output: 0.16,
            cacheRead: 0.01,
            cacheWrite: 0.04,
          },
        },
      },
    },
  },
  "amazon/nova-pro": {
    id: "amazon/nova-pro",
    lab: "amazon",
    name: "Nova Pro",
    family: "nova-pro",
    releaseDate: "2024-12-03",
    knowledge: "2024-10",
    modalities: {
      input: ["text", "image", "video", "pdf"],
      output: ["text"],
    },
    reasoning: false,
    toolCall: true,
    temperature: true,
    limit: {
      context: 300000,
      output: 10000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "amazon.nova-pro-v1:0": {
          name: "Nova Pro",
          cost: {
            input: 0.8,
            output: 3.2,
            cacheRead: 0.2,
            cacheWrite: 0.8,
          },
        },
        "eu.amazon.nova-pro-v1:0": {
          name: "Nova Pro (EU)",
          cost: {
            input: 0.92,
            output: 3.68,
            cacheRead: 0.23,
            cacheWrite: 0.92,
          },
        },
      },
    },
  },
  "anthropic/claude-fable-5": {
    id: "anthropic/claude-fable-5",
    lab: "anthropic",
    name: "Claude Fable 5",
    family: "claude-fable",
    releaseDate: "2026-06-09",
    knowledge: "2026-01-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-fable-5": {
          name: "Claude Fable 5",
          cost: {
            input: 10,
            output: 50,
            cacheRead: 1,
            cacheWrite: 12.5,
          },
        },
        "eu.anthropic.claude-fable-5": {
          name: "Claude Fable 5 (EU)",
          cost: {
            input: 11,
            output: 55,
            cacheRead: 1.1,
            cacheWrite: 13.75,
          },
        },
        "global.anthropic.claude-fable-5": {
          name: "Claude Fable 5 (Global)",
          cost: {
            input: 10,
            output: 50,
            cacheRead: 1,
            cacheWrite: 12.5,
          },
        },
      },
    },
  },
  "anthropic/claude-fable-5-1": {
    id: "anthropic/claude-fable-5-1",
    lab: "anthropic",
    name: "Claude Fable 5.1",
    family: "claude-fable",
    releaseDate: "2026-09-01",
    knowledge: "2026-06",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-fable-5-1": {
          name: "Claude Fable 5.1",
          cost: {
            input: 10,
            output: 50,
            cacheRead: 0.25,
            cacheWrite: 12.5,
          },
        },
        "global.anthropic.claude-fable-5-1": {
          name: "Claude Fable 5.1 (Global)",
          cost: {
            input: 10,
            output: 50,
            cacheRead: 0.25,
            cacheWrite: 12.5,
          },
        },
      },
    },
  },
  "anthropic/claude-haiku-4-5-20251001": {
    id: "anthropic/claude-haiku-4-5-20251001",
    lab: "anthropic",
    name: "Claude Haiku 4.5",
    family: "claude-haiku",
    releaseDate: "2025-10-15",
    knowledge: "2025-02-28",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 200000,
      output: 64000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-haiku-4-5-20251001-v1:0": {
          name: "Claude Haiku 4.5",
          cost: {
            input: 1,
            output: 5,
            cacheRead: 0.1,
            cacheWrite: 1.25,
          },
        },
        "eu.anthropic.claude-haiku-4-5-20251001-v1:0": {
          name: "Claude Haiku 4.5 (EU)",
          cost: {
            input: 1.1,
            output: 5.5,
            cacheRead: 0.11,
            cacheWrite: 1.375,
          },
        },
        "global.anthropic.claude-haiku-4-5-20251001-v1:0": {
          name: "Claude Haiku 4.5 (Global)",
          cost: {
            input: 1,
            output: 5,
            cacheRead: 0.1,
            cacheWrite: 1.25,
          },
        },
      },
    },
  },
  "anthropic/claude-haiku-5-5": {
    id: "anthropic/claude-haiku-5-5",
    lab: "anthropic",
    name: "Claude Haiku 5.5",
    family: "claude-haiku",
    releaseDate: "2026-10-07",
    knowledge: "2026-06",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-haiku-5-5": {
          name: "Claude Haiku 5.5",
          cost: {
            input: 0.1,
            output: 0.5,
            cacheRead: 0.01,
            cacheWrite: 0.125,
            tiers: [
              {
                contextSize: 100000,
                input: 0.5,
                output: 2.5,
                cacheRead: 0.05,
                cacheWrite: 0.625,
              },
            ],
          },
        },
        "eu.anthropic.claude-haiku-5-5": {
          name: "Claude Haiku 5.5 (EU)",
          cost: {
            input: 0.11,
            output: 0.55,
            cacheRead: 0.011,
            cacheWrite: 0.1375,
            tiers: [
              {
                contextSize: 100000,
                input: 0.55,
                output: 2.75,
                cacheRead: 0.055,
                cacheWrite: 0.6875,
              },
            ],
          },
        },
        "global.anthropic.claude-haiku-5-5": {
          name: "Claude Haiku 5.5 (Global)",
          cost: {
            input: 0.1,
            output: 0.5,
            cacheRead: 0.01,
            cacheWrite: 0.125,
            tiers: [
              {
                contextSize: 100000,
                input: 0.5,
                output: 2.5,
                cacheRead: 0.05,
                cacheWrite: 0.625,
              },
            ],
          },
        },
      },
    },
  },
  "anthropic/claude-opus-4-5-20251101": {
    id: "anthropic/claude-opus-4-5-20251101",
    lab: "anthropic",
    name: "Claude Opus 4.5",
    family: "claude-opus",
    releaseDate: "2025-11-24",
    knowledge: "2025-05",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 200000,
      output: 64000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-4-5-20251101-v1:0": {
          name: "Claude Opus 4.5",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
        "eu.anthropic.claude-opus-4-5-20251101-v1:0": {
          name: "Claude Opus 4.5 (EU)",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "global.anthropic.claude-opus-4-5-20251101-v1:0": {
          name: "Claude Opus 4.5 (Global)",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
      },
    },
  },
  "anthropic/claude-opus-4-6": {
    id: "anthropic/claude-opus-4-6",
    lab: "anthropic",
    name: "Claude Opus 4.6",
    family: "claude-opus",
    releaseDate: "2026-02-05",
    knowledge: "2025-05-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-4-6-v1": {
          name: "Claude Opus 4.6",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "eu.anthropic.claude-opus-4-6-v1": {
          name: "Claude Opus 4.6 (EU)",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "global.anthropic.claude-opus-4-6-v1": {
          name: "Claude Opus 4.6 (Global)",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
      },
    },
  },
  "anthropic/claude-opus-4-7": {
    id: "anthropic/claude-opus-4-7",
    lab: "anthropic",
    name: "Claude Opus 4.7",
    family: "claude-opus",
    releaseDate: "2026-04-16",
    knowledge: "2026-01-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-4-7": {
          name: "Claude Opus 4.7",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
        "eu.anthropic.claude-opus-4-7": {
          name: "Claude Opus 4.7 (EU)",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "global.anthropic.claude-opus-4-7": {
          name: "Claude Opus 4.7 (Global)",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
      },
    },
  },
  "anthropic/claude-opus-4-8": {
    id: "anthropic/claude-opus-4-8",
    lab: "anthropic",
    name: "Claude Opus 4.8",
    family: "claude-opus",
    releaseDate: "2026-05-28",
    knowledge: "2026-01",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-4-8": {
          name: "Claude Opus 4.8",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
        "eu.anthropic.claude-opus-4-8": {
          name: "Claude Opus 4.8 (EU)",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "global.anthropic.claude-opus-4-8": {
          name: "Claude Opus 4.8 (Global)",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
      },
    },
  },
  "anthropic/claude-opus-5": {
    id: "anthropic/claude-opus-5",
    lab: "anthropic",
    name: "Claude Opus 5",
    family: "claude-opus",
    releaseDate: "2026-07-24",
    knowledge: "2026-05",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-5": {
          name: "Claude Opus 5",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
        "eu.anthropic.claude-opus-5": {
          name: "Claude Opus 5 (EU)",
          cost: {
            input: 5.5,
            output: 27.5,
            cacheRead: 0.55,
            cacheWrite: 6.875,
          },
        },
        "global.anthropic.claude-opus-5": {
          name: "Claude Opus 5 (Global)",
          cost: {
            input: 5,
            output: 25,
            cacheRead: 0.5,
            cacheWrite: 6.25,
          },
        },
      },
    },
  },
  "anthropic/claude-opus-5-5": {
    id: "anthropic/claude-opus-5-5",
    lab: "anthropic",
    name: "Claude Opus 5.5",
    family: "claude-opus",
    releaseDate: "2026-09-22",
    knowledge: "2026-06",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-opus-5-5": {
          name: "Claude Opus 5.5",
          cost: {
            input: 4,
            output: 20,
            cacheRead: 0.2,
            cacheWrite: 5,
          },
        },
        "eu.anthropic.claude-opus-5-5": {
          name: "Claude Opus 5.5 (EU)",
          cost: {
            input: 4.4,
            output: 22,
            cacheRead: 0.22,
            cacheWrite: 5.5,
          },
        },
        "global.anthropic.claude-opus-5-5": {
          name: "Claude Opus 5.5 (Global)",
          cost: {
            input: 4,
            output: 20,
            cacheRead: 0.2,
            cacheWrite: 5,
          },
        },
      },
    },
  },
  "anthropic/claude-sonnet-4-20250514": {
    id: "anthropic/claude-sonnet-4-20250514",
    lab: "anthropic",
    name: "Claude Sonnet 4",
    family: "claude-sonnet",
    releaseDate: "2025-05-22",
    knowledge: "2025-03-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 200000,
      output: 64000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "eu.anthropic.claude-sonnet-4-20250514-v1:0": {
          name: "Claude Sonnet 4 (EU)",
          status: "deprecated",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
        "global.anthropic.claude-sonnet-4-20250514-v1:0": {
          name: "Claude Sonnet 4 (Global)",
          status: "deprecated",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
      },
    },
  },
  "anthropic/claude-sonnet-4-5-20250929": {
    id: "anthropic/claude-sonnet-4-5-20250929",
    lab: "anthropic",
    name: "Claude Sonnet 4.5",
    family: "claude-sonnet",
    releaseDate: "2025-09-29",
    knowledge: "2025-07-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 200000,
      output: 64000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-sonnet-4-5-20250929-v1:0": {
          name: "Claude Sonnet 4.5",
          status: "deprecated",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
        "eu.anthropic.claude-sonnet-4-5-20250929-v1:0": {
          name: "Claude Sonnet 4.5 (EU)",
          status: "deprecated",
          cost: {
            input: 3.3,
            output: 16.5,
            cacheRead: 0.33,
            cacheWrite: 4.125,
          },
        },
        "global.anthropic.claude-sonnet-4-5-20250929-v1:0": {
          name: "Claude Sonnet 4.5 (Global)",
          status: "deprecated",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
      },
    },
  },
  "anthropic/claude-sonnet-4-6": {
    id: "anthropic/claude-sonnet-4-6",
    lab: "anthropic",
    name: "Claude Sonnet 4.6",
    family: "claude-sonnet",
    releaseDate: "2026-02-17",
    knowledge: "2025-08-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 1000000,
      output: 64000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-sonnet-4-6": {
          name: "Claude Sonnet 4.6",
          cost: {
            input: 3.3,
            output: 16.5,
            cacheRead: 0.33,
            cacheWrite: 4.125,
          },
        },
        "eu.anthropic.claude-sonnet-4-6": {
          name: "Claude Sonnet 4.6 (EU)",
          cost: {
            input: 3.3,
            output: 16.5,
            cacheRead: 0.33,
            cacheWrite: 4.125,
          },
        },
        "global.anthropic.claude-sonnet-4-6": {
          name: "Claude Sonnet 4.6 (Global)",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
      },
    },
  },
  "anthropic/claude-sonnet-5": {
    id: "anthropic/claude-sonnet-5",
    lab: "anthropic",
    name: "Claude Sonnet 5",
    family: "claude-sonnet",
    releaseDate: "2026-06-30",
    knowledge: "2026-01-31",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-sonnet-5": {
          name: "Claude Sonnet 5",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.2,
            cacheWrite: 2.5,
          },
        },
        "eu.anthropic.claude-sonnet-5": {
          name: "Claude Sonnet 5 (EU)",
          cost: {
            input: 2.2,
            output: 11,
            cacheRead: 0.22,
            cacheWrite: 2.75,
          },
        },
        "global.anthropic.claude-sonnet-5": {
          name: "Claude Sonnet 5 (Global)",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.2,
            cacheWrite: 2.5,
          },
        },
      },
    },
  },
  "anthropic/claude-sonnet-5-5": {
    id: "anthropic/claude-sonnet-5-5",
    lab: "anthropic",
    name: "Claude Sonnet 5.5",
    family: "claude-sonnet",
    releaseDate: "2026-09-28",
    knowledge: "2026-06",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1000000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "anthropic.claude-sonnet-5-5": {
          name: "Claude Sonnet 5.5",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.1,
            cacheWrite: 2.5,
          },
        },
        "eu.anthropic.claude-sonnet-5-5": {
          name: "Claude Sonnet 5.5 (EU)",
          cost: {
            input: 2.2,
            output: 11,
            cacheRead: 0.11,
            cacheWrite: 2.75,
          },
        },
        "global.anthropic.claude-sonnet-5-5": {
          name: "Claude Sonnet 5.5 (Global)",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.1,
            cacheWrite: 2.5,
          },
        },
      },
    },
  },
  "mistral/pixtral-large-2502": {
    id: "mistral/pixtral-large-2502",
    lab: "mistral",
    name: "Pixtral Large (25.02)",
    family: "pixtral",
    releaseDate: "2025-04-08",
    modalities: {
      input: ["text", "image"],
      output: ["text"],
    },
    reasoning: false,
    toolCall: true,
    temperature: true,
    limit: {
      context: 128000,
      output: 8192,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "eu.mistral.pixtral-large-2502-v1:0": {
          name: "Pixtral Large (25.02) (EU)",
          cost: {
            input: 2,
            output: 6,
          },
        },
        "mistral.pixtral-large-2502-v1:0": {
          name: "Pixtral Large (25.02)",
          cost: {
            input: 2,
            output: 6,
          },
        },
      },
    },
  },
  "moonshotai/kimi-k3": {
    id: "moonshotai/kimi-k3",
    lab: "moonshotai",
    name: "Kimi K3",
    family: "kimi-k3",
    releaseDate: "2026-07-16",
    modalities: {
      input: ["text", "image", "video"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1048576,
      output: 131072,
    },
    openWeights: true,
    upstream: {
      bedrock: {
        "global.moonshotai.kimi-k3": {
          name: "Kimi K3 (Global)",
          cost: {
            input: 3,
            output: 15,
            cacheRead: 0.3,
            cacheWrite: 3.75,
          },
        },
      },
    },
  },
  "openai/gpt-5.6-luna": {
    id: "openai/gpt-5.6-luna",
    lab: "openai",
    name: "GPT-5.6 Luna",
    family: "gpt-luna",
    releaseDate: "2026-07-09",
    knowledge: "2026-02-16",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-5.6-luna": {
          name: "GPT-5.6 Luna (Global)",
          cost: {
            input: 0.2,
            output: 1.2,
            cacheRead: 0.02,
            cacheWrite: 0.25,
            tiers: [
              {
                contextSize: 272000,
                input: 0.4,
                output: 1.8,
                cacheRead: 0.04,
                cacheWrite: 0.5,
              },
            ],
          },
        },
        "openai.gpt-5.6-luna": {
          name: "GPT-5.6 Luna",
          cost: {
            input: 0.22,
            output: 1.32,
            cacheRead: 0.022,
            cacheWrite: 0.275,
            tiers: [
              {
                contextSize: 272000,
                input: 0.44,
                output: 1.98,
                cacheRead: 0.044,
                cacheWrite: 0.55,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-5.6-sol": {
    id: "openai/gpt-5.6-sol",
    lab: "openai",
    name: "GPT-5.6 Sol",
    family: "gpt-sol",
    releaseDate: "2026-07-09",
    knowledge: "2026-02-16",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-5.6-sol": {
          name: "GPT-5.6 Sol (Global)",
          cost: {
            input: 4,
            output: 20,
            cacheRead: 0.4,
            cacheWrite: 5,
            tiers: [
              {
                contextSize: 272000,
                input: 8,
                output: 30,
                cacheRead: 0.8,
                cacheWrite: 10,
              },
            ],
          },
        },
        "openai.gpt-5.6-sol": {
          name: "GPT-5.6 Sol",
          cost: {
            input: 4.4,
            output: 22,
            cacheRead: 0.44,
            cacheWrite: 5.5,
            tiers: [
              {
                contextSize: 272000,
                input: 8.8,
                output: 33,
                cacheRead: 0.88,
                cacheWrite: 11,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-5.6-terra": {
    id: "openai/gpt-5.6-terra",
    lab: "openai",
    name: "GPT-5.6 Terra",
    family: "gpt-terra",
    releaseDate: "2026-07-09",
    knowledge: "2026-02-16",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-5.6-terra": {
          name: "GPT-5.6 Terra (Global)",
          cost: {
            input: 2,
            output: 12,
            cacheRead: 0.2,
            cacheWrite: 2.5,
            tiers: [
              {
                contextSize: 272000,
                input: 4,
                output: 18,
                cacheRead: 0.4,
                cacheWrite: 5,
              },
            ],
          },
        },
        "openai.gpt-5.6-terra": {
          name: "GPT-5.6 Terra",
          cost: {
            input: 2.2,
            output: 13.2,
            cacheRead: 0.22,
            cacheWrite: 2.75,
            tiers: [
              {
                contextSize: 272000,
                input: 4.4,
                output: 19.8,
                cacheRead: 0.44,
                cacheWrite: 5.5,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-6-astra": {
    id: "openai/gpt-6-astra",
    lab: "openai",
    name: "GPT-6 Astra",
    family: "gpt-astra",
    releaseDate: "2026-09-04",
    knowledge: "2026-04-30",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-6-astra": {
          name: "GPT-6 Astra (Global)",
          cost: {
            input: 10,
            output: 50,
            cacheRead: 1,
            cacheWrite: 12.5,
            tiers: [
              {
                contextSize: 272000,
                input: 20,
                output: 75,
                cacheRead: 2,
                cacheWrite: 25,
              },
            ],
          },
        },
        "openai.gpt-6-astra": {
          name: "GPT-6 Astra",
          cost: {
            input: 11,
            output: 55,
            cacheRead: 1.1,
            cacheWrite: 13.75,
            tiers: [
              {
                contextSize: 272000,
                input: 22,
                output: 82.5,
                cacheRead: 2.2,
                cacheWrite: 27.5,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-6-luna": {
    id: "openai/gpt-6-luna",
    lab: "openai",
    name: "GPT-6 Luna",
    family: "gpt-luna",
    releaseDate: "2026-09-22",
    knowledge: "2026-05-18",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-6-luna": {
          name: "GPT-6 Luna (Global)",
          cost: {
            input: 0.1,
            output: 0.5,
            cacheRead: 0.01,
            cacheWrite: 0.125,
            tiers: [
              {
                contextSize: 272000,
                input: 0.2,
                output: 0.75,
                cacheRead: 0.02,
                cacheWrite: 0.25,
              },
            ],
          },
        },
        "openai.gpt-6-luna": {
          name: "GPT-6 Luna",
          cost: {
            input: 0.11,
            output: 0.55,
            cacheRead: 0.011,
            cacheWrite: 0.1375,
            tiers: [
              {
                contextSize: 272000,
                input: 0.22,
                output: 0.825,
                cacheRead: 0.022,
                cacheWrite: 0.275,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-6-sol": {
    id: "openai/gpt-6-sol",
    lab: "openai",
    name: "GPT-6 Sol",
    family: "gpt-sol",
    releaseDate: "2026-09-22",
    knowledge: "2026-04-20",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-6-sol": {
          name: "GPT-6 Sol (Global)",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.2,
            cacheWrite: 2.5,
            tiers: [
              {
                contextSize: 272000,
                input: 4,
                output: 15,
                cacheRead: 0.4,
                cacheWrite: 5,
              },
            ],
          },
        },
        "openai.gpt-6-sol": {
          name: "GPT-6 Sol",
          cost: {
            input: 2.2,
            output: 11,
            cacheRead: 0.22,
            cacheWrite: 2.75,
            tiers: [
              {
                contextSize: 272000,
                input: 4.4,
                output: 16.5,
                cacheRead: 0.44,
                cacheWrite: 5.5,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-6.1-sol": {
    id: "openai/gpt-6.1-sol",
    lab: "openai",
    name: "GPT-6.1 Sol",
    family: "gpt-sol",
    releaseDate: "2026-09-29",
    knowledge: "2026-04-30",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-6.1-sol": {
          name: "GPT-6.1 Sol (Global)",
          cost: {
            input: 2,
            output: 10,
            cacheRead: 0.1,
            cacheWrite: 2.5,
            tiers: [
              {
                contextSize: 272000,
                input: 4,
                output: 15,
                cacheRead: 0.2,
                cacheWrite: 5,
              },
            ],
          },
        },
        "openai.gpt-6.1-sol": {
          name: "GPT-6.1 Sol",
          cost: {
            input: 2.2,
            output: 11,
            cacheRead: 0.11,
            cacheWrite: 2.75,
            tiers: [
              {
                contextSize: 272000,
                input: 4.4,
                output: 16.5,
                cacheRead: 0.22,
                cacheWrite: 5.5,
              },
            ],
          },
        },
      },
    },
  },
  "openai/gpt-6.1-terra": {
    id: "openai/gpt-6.1-terra",
    lab: "openai",
    name: "GPT-6.1 Terra",
    family: "gpt-terra",
    releaseDate: "2026-10-26",
    knowledge: "2026-06-01",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: false,
    limit: {
      context: 1050000,
      output: 128000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.openai.gpt-6.1-terra": {
          name: "GPT-6.1 Terra (Global)",
          cost: {
            input: 1,
            output: 5,
            cacheRead: 0.05,
            cacheWrite: 1.25,
            tiers: [
              {
                contextSize: 272000,
                input: 2,
                output: 7.5,
                cacheRead: 0.1,
                cacheWrite: 2.5,
              },
            ],
          },
        },
        "openai.gpt-6.1-terra": {
          name: "GPT-6.1 Terra",
          cost: {
            input: 1.1,
            output: 5.5,
            cacheRead: 0.055,
            cacheWrite: 1.375,
            tiers: [
              {
                contextSize: 272000,
                input: 2.2,
                output: 8.25,
                cacheRead: 0.11,
                cacheWrite: 2.75,
              },
            ],
          },
        },
      },
    },
  },
  "xai/grok-4.6": {
    id: "xai/grok-4.6",
    lab: "xai",
    name: "Grok 4.6",
    family: "grok",
    releaseDate: "2026-08-12",
    knowledge: "2026-02-01",
    modalities: {
      input: ["text", "image"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 500000,
      output: 500000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.xai.grok-4.6": {
          name: "Grok 4.6 (Global)",
          cost: {
            input: 2,
            output: 6,
            cacheRead: 0.5,
          },
        },
        "xai.grok-4.6": {
          name: "Grok 4.6",
          cost: {
            input: 2.2,
            output: 6.6,
            cacheRead: 0.55,
          },
        },
      },
    },
  },
  "xai/grok-4.7": {
    id: "xai/grok-4.7",
    lab: "xai",
    name: "Grok 4.7",
    family: "grok",
    releaseDate: "2026-09-21",
    knowledge: "2026-05",
    modalities: {
      input: ["text", "image", "pdf"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 500000,
      output: 500000,
    },
    openWeights: false,
    upstream: {
      bedrock: {
        "global.xai.grok-4.7": {
          name: "Grok 4.7 (Global)",
          cost: {
            input: 2,
            output: 6,
            cacheRead: 0.5,
          },
        },
      },
    },
  },
  "zhipuai/glm-5.3": {
    id: "zhipuai/glm-5.3",
    lab: "zhipuai",
    name: "GLM-5.3",
    family: "glm",
    releaseDate: "2026-08-14",
    modalities: {
      input: ["text"],
      output: ["text"],
    },
    reasoning: true,
    toolCall: true,
    temperature: true,
    limit: {
      context: 1000000,
      output: 131072,
    },
    openWeights: true,
    upstream: {
      bedrock: {
        "global.zai.glm-5.3": {
          name: "GLM-5.3 (Global)",
          cost: {
            input: 1.68,
            output: 5.28,
            cacheRead: 0.312,
            cacheWrite: 2.1,
          },
        },
      },
    },
  },
};
